import * as React from "react";
import AuthCompleteRouteBase from "../../features/auth/routes/auth-complete";
export default function AuthCompleteRoute() {
    return React.createElement(AuthCompleteRouteBase, null);
}
